module.exports = "<span class=\"js-text reference-field__txt btn-wrp\" title=\"{{text}}\">\r\n    {{#if text}}\r\n        {{text}}\r\n    {{else}}\r\n        <span class=\"member-text__empty\">{{localize 'CORE.FORM.EDITORS.MEMBERSELECT.NOTSET'}}</span>\r\n    {{/if}}\r\n</span>\r\n<div class=\"svg-icons-wrp\">\r\n    <div class=\"js-clear-button svg-icons-wrp__remove\">\r\n        <svg class=\"svg-icons svg-icons_remove\"><use xlink:href=\"#icon-remove\" /> </svg>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/reference/templates/userReferenceButton.hbs
// module id = 679
// module chunks = 0